/*************************************************
 Scripts for individual content blocks.
*************************************************/

jQuery(function ($) {
    /**
     * Hero Block
     */
    if ($('.blk__hero').length) {
        // Background video stretch.
        const heroVideoStrecth = () => {
            $('.blk__hero').each(function () {
                if ($(this).hasClass('bg-video')) {
                    const height = $(this).outerHeight();
                    const width = $(this).outerWidth();
                    $(this).find('.hero-background-video').css('height', height);
                    // vimeo player background=1 param is only avaiable for plus accounts.
                    // 0.8 is to cut off top and bottom 10% of the video where the controls are located.
                    $(this).find('.hero-background-video').css('width', Math.max(height / 9 / 0.8 * 16, width));
                }
            })
        }

        heroVideoStrecth();
        let resizeTimer = 0;
        $(window).on('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                heroVideoStrecth();
            }, 50)
        })

        // Play toggle button click.
        $(document).on("click", '.icon-video-control', function () {
            const iframe = $(this).parent().find(".hero-background-video iframe");
            if (iframe.length) {
                const command = $(this).hasClass("icon-pause") ? 'pause' : 'play'
                if ($(this).hasClass("youtube-video")) {
                    iframe[0].contentWindow.postMessage(`{"event":"command","func":"${command}Video","args":""}`, '*')
                } else if ($(this).hasClass("vimeo-video")) {
                    iframe[0].contentWindow.postMessage(`{"method":"${command}"}`, '*')
                }
                $(this).toggleClass("icon-pause").toggleClass("icon-play")
            }
        })


        // Youtube video loading fallback.
        window.onYouTubeIframeAPIReady = () => {
            $('.blk__hero').each(function () {
                if ($(this).find('.hero-background-video').hasClass('youtube-video')) {
                    const replace = $(this).find('.video-replace');
                    const videoId = replace.data('video_id');
                    new YT.Player(replace.attr('id'), {
                        videoId,
                        playerVars: {
                            mute: replace.data('mute'),
                            autoplay: replace.data('autoplay'),
                            loop: 1,
                            controls: 0,
                            showinfo: 0,
                            playsinline: 1,
                            autohide: 1,
                            enablejsapi: 1,
                            modestbranding: 1,
                            rel: 0,
                            disablekb: 1,
                            playlist: videoId
                        },
                        allowfullscreen: 0,
                        events: {
                            'onReady': onPlayerReady,
                            'onStateChange': onPlayerStateChange
                        }
                    });
                }
            })
        }
        function onPlayerReady(e) {
            if (1 === $(e.target.f).data('autoplay')) {
                // Force autoplay on mobile also.
                e.target.playVideo();
            }
        }
        function onPlayerStateChange(e) {
            if (1 === e.data) { // Video Playing.
                $(e.target.f).closest('.content_block').find('.thumbnail-background').hide();
                $(e.target.f).closest('.content_block').find('.icon-video-control').show(); // No need to hide once video is loaded.
            } else if (0 === e.data) {
                $(e.target.f).closest('.content_block').find('.thumbnail-background').show(); // Video Ended.
            }
        }
    }

    /**
     * Countdown Block
     */
    if ($('.blk__countdown').length) {
        const updateCountdown = (countDownDate, el) => {
            // Get today's date and time
            const now = new Date().getTime();

            // Find the distance between now and the count down date
            const distance = countDownDate - now;
            if (distance < 0) {
                return distance;
            }
            // Time calculations for days, hours, minutes and seconds
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // Output the result in an element with id="demo"
            el.find('.days').text((days < 10 ? '0' : '') + days);
            el.find('.hours').text((hours < 10 ? '0' : '') + hours);
            el.find('.minutes').text((minutes < 10 ? '0' : '') + minutes);
            el.find('.seconds').text((seconds < 10 ? '0' : '') + seconds);

            return distance;
        }

        $('.blk__countdown').each(function () {
            const el = $(this);
            const event_time = el.data('event_time')
            if (!event_time) return;

            const countDownDate = new Date(event_time);
            updateCountdown(countDownDate, el);

            const timer = setInterval(function () {
                const distance = updateCountdown(countDownDate, el);

                // If the count down is over, write some text 
                if (distance < 0) {
                    clearInterval(timer);
                    el.slideUp()
                }
            }, 1000);
        })
    }

    /**
     * Club signup form
     */
    if ($('.blk__subscribe_form').length) {
        $('.blk__subscribe_form').each(function () {
            const $form = $(this);
            const clubId = $form.data('club');
            const formId = $form.data('form');
            const tenant = theme_object.tenant;

            if (!tenant || !clubId) {
                $form.find('.inner').append('<div>Tenant ID or Club ID is missing.</div>')
                return;
            }

            const clubSignupId = $.cookie(`clubSignupId`);
            const customerToken = $.cookie(`customerToken`);

            console.log('clubSignupId', clubSignupId)
            console.log('customerToken', customerToken)
            console.log('clubId', clubId)

            if (customerToken) {
                $.removeCookie(`clubSignupId`);
                $.removeCookie(`customerToken`);
            }

            $.ajax({
                url: "https://api.commerce7.com/v1/club-signup/" + (clubSignupId && 'null' !== clubSignupId ? clubSignupId : ''),
                data: { clubId },
                headers: { tenant },
                type: clubSignupId && 'null' !== clubSignupId ? "GET" : "POST",
                success: function (response) {
                    console.log('new clubSignupId', response.id)
                    $form.find('.gform_wrapper').show();
                    $form.find('.clubSignupId input').val(response.id)
                    $form.find('.clubId input').val(clubId)
                    $.cookie(`clubSignupId`, response.id, { expires: 7 });
                },
                error: function (response) {
                    for (let error of response.responseJSON.errors) {
                        $form.find('.inner').append(`<div>${error.field} ${error.message}</div>`)
                    }
                }
            });
        })

        gform.addFilter('gform_chosen_options', function (options, element) {
            // Favourite Wine limit ---  limit how many options may be chosen in a multi-select to 3.
            if ('input_51[]' === element.attr('name')) {
                options.max_selected_options = 3;
            }
            return options;
        });

        // Fake loading animation effect.
        $(document).on('gform_confirmation_loaded', function (event, formId) {
            $.cookie(`clubSignupId`, null);
            let totalTimeElapsed = 4;
            const is_small_tablet = window.innerWidth < 640;
            const block = $(`.blk__subscribe_form[data-form="${formId}"]`);
            block.addClass('confirmation-loading')
            block.find('.reviewing > div').each(function (index, el) {
                const rand = Math.random() / 2; // random delay between 0 to 0.5.
                totalTimeElapsed += rand;
                setTimeout(() => { $(el).css("display", is_small_tablet ? 'block' : "flex").hide().fadeIn(500) }, 3000 * index + rand)
                setTimeout(() => { $(el).find('.checkmark').fadeIn(500) }, 3000 * index + 2000 + rand)
            })
            setTimeout(function () {
                block.removeClass('confirmation-loading').addClass('confirmation-loaded')
            }, 2500 * totalTimeElapsed + 500)
        });
    }
})
